import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PurchaseSuggestionsDialogComponent } from '../../purchase-suggestions-dialog/purchase-suggestions-dialog.component';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { LocaleService } from 'src/app/services/locale.service';
import { CustomerType } from '../../../models/client-configuration';

@Component({
  selector: 'app-user-suggestions',
  templateUrl: './user-suggestions.component.html',
  styleUrls: ['./user-suggestions.component.scss'],
})
export class UserSuggestionsComponent implements OnInit {
  section = 'suggestions';
  customerType: CustomerType;
  textDirection: string;
  isLoading = true;

  constructor(
    router: Router,
    public userService: UserService,
    private configService: ConfigService,
    private localeService: LocaleService,
    private dialog: MatDialog
  ) {
    if (!configService.get().showPurchaseSuggestions) {
      router.navigate(['/user/checkouts']);
    }
    this.textDirection = this.localeService.getTextDirection();
  }

  ngOnInit() {
    this.customerType = this.configService.customerType;
    this.userService.loadPurchaseSuggestions().subscribe({
      next: () => (this.isLoading = false),
      error: () => (this.isLoading = false),
    });
  }

  openSuggestionsDialog() {
    this.dialog.open(PurchaseSuggestionsDialogComponent, {
      data: new SearchModel(),
    });
  }
}
